import React from "react";
import { Grid, Segment, Header, Table, Loader, Tab } from "semantic-ui-react";
import { StatCard } from "../../StatCard";
import "./EnrollmentTab.scss";

export function EnrollmentTab(props) {
  const { enrollmentData } = props;

  if (!enrollmentData) {
    return <Loader active>Cargando datos de matrícula...</Loader>;
  }

  return (
    <Tab.Pane>
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column>
            <StatCard
              title="Total Estudiantes"
              value={enrollmentData.summary?.totalActiveStudents || 0}
              icon="users"
              color="#2185d0"
            />
          </Grid.Column>
          <Grid.Column>
            <StatCard
              title="Grados por nivel"
              value={enrollmentData.summary?.distributionByGrade || 0}
              icon="list"
              color="#f2711c"
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={2}>
          <Grid.Column width={16}>
            <Segment>
              <Header as="h4">Estudiantes por Grado</Header>
              {enrollmentData.studentsByGrade &&
              enrollmentData.studentsByGrade.length > 0 ? (
                <Table basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Grado</Table.HeaderCell>
                      <Table.HeaderCell textAlign="right">
                        Estudiantes
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {enrollmentData.studentsByGrade
                      .slice(0, 10)
                      .map((grade) => (
                        <Table.Row key={grade.gradeName}>
                          <Table.Cell>{grade.gradeName}</Table.Cell>
                          <Table.Cell textAlign="right">
                            {grade.count}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              ) : (
                <p>No hay datos disponibles</p>
              )}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Tab.Pane>
  );
}
